// src/components/Layout/Header.jsx
import React from 'react';
import { useAuth } from '../../context/AuthContext';

const Header = ({ toggleSidebar, isCollapsed }) => {
  const { user, logout } = useAuth();
  console.log("🚀 ~ Header ~ user:", user)

  const getRoleDisplay = (role) => {
    switch(role) {
      case 'admin':
        return 'Super Admin';
      case 'sub-admin':
        return 'Sub Admin';
      case 'distributor':
        return 'Distributor';
      case 'retailer':
        return 'Retailer';
      default:
        return role;
    }
  };

  const handleMenuClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (toggleSidebar) {
      toggleSidebar();
    }
  };

  return (
    <header className="admin-header">
      <div className="ad-header-left">
          <button className="menu-btn" onClick={handleMenuClick}><img src="/img/menu-icon.png" alt="Menu" /></button>
          <h3 className="userid">{user?.username}</h3>
      </div>
      <h3 className="admin-name">{user ? getRoleDisplay(user.role) : 'Loading...'}</h3>
      <div className="ad-header-right">
        <h3 className="user-points"> Points: {(user?.walletBalance)?.toFixed(2) || 0}</h3>       
          {/* <div className="notification-icon"> <img src="/img/notification-icon.png" alt="" /> </div> */}
        <div className="dropdown profile-drop">
          <button className="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
            <img src="/img/user-img.png" alt="User" />
          </button>
          <ul className="dropdown-menu">
            <div className="dropdown-item" style={{ fontWeight: 'bold' }}>
              {user?.username || user?.fullName }
            </div>
            <div className="dropdown-item" style={{ fontSize: '12px', color: '#ffd700' }}>
              Role: {getRoleDisplay(user?.role)}
            </div>
            {user?.commissionRate > 0 && (
              <div className="dropdown-item" style={{ fontSize: '12px' }}>
                Commission: {user.commissionRate}%
              </div>
            )}
            {/* {user?.walletBalance !== undefined && (
              <div className="dropdown-item" style={{ fontSize: '12px' }}>
                Balance: ₹{user.walletBalance.toFixed(2)}
              </div>
            )} */}
            <li><hr className="dropdown-divider"/></li>
            <li>
              <button className="logout-admin" onClick={logout}>
                <i className="fa-solid fa-arrow-right-from-bracket"></i> Logout
              </button>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;